export default {
    bot_description: "Bot description",
    bot_name: "Bot name",
    clinic_account: "Clinic account",
    clinic_site_link: "Clinic website link",
    code_for_bonus_payment: "Code for bonus payment",
    code_was_not_sent: "Code was not sent - the patient needs to check the connection to the Telegram bot",
    code_was_sent_to_patient_through_bot: "Code was sent to the patient through telegram bot",
    connected_to_telegram_bot: "Connected to Telegram bot",
    max_bot: "Max bot",
    telegram_bot: "Telegram bot",
    telegram_bot_default_description: "The bot helps the clinic's patients accumulate bonuses and receive up-to-date information about their visits",
    telegram_bot_instruction_1: "Open the Telegram messenger, log in to your account or create a new one. Enter <code>{'@'}BotFather</code> in the search field and select the bot",
    telegram_bot_instruction_2: "Select or type and send the command <code>/newbot</code>",
    telegram_bot_instruction_3: "Give a name to the bot — clients will see this name when communicating with the bot. Also give a bot nickname — it can be used to find the bot in Telegram. The nickname must be unique, not repeat existing ones in the database, and end with the word 'bot'",
    telegram_bot_instruction_4: "Copy the token value of the created bot, paste it in the field below, and save it",
    use_bonuses_by_confirming_through_telegram_bot: "Use bonuses by confirming through Telegram bot",
    wrong_code: "The code is incorrect"
}
